import { AnalyticsCharts } from "@components/analytics/analytics-charts";
import { Grid2 } from "@mui/material";
import { AnalyticsInfoBar } from "@pages/analytics/analytics-info-bar";
import { useAppParams } from "@router/router-helper";
import { fetchCompanyStats } from "@store/analytics/analytics-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";

/** Renders workspace tabs in analytics page */
export function WorkspaceAnalytics(): JSX.Element {
  const dispatch = useAppDispatch();
  const { companyId } = useAppParams();

  useEffect(() => {
    function fetchStats(): void {
      void dispatch(
        fetchCompanyStats({
          companyId: companyId ?? "",
        })
      );
    }

    fetchStats();
  }, [companyId, dispatch]);

  return (
    <Grid2 width="100%">
      <AnalyticsInfoBar />
      <AnalyticsCharts />
    </Grid2>
  );
}
